export const ACTIVITY_INCIDENT_RECORD = 'ACTIVITY_INCIDENT_RECORD';

export const GET_INCIDENT_RECORD = 'GET_INCIDENT_RECORD';
export const CLEAR_INCIDENT_RECORD = 'CLEAR_INCIDENT_RECORD';
export const FLAG_ACTIVITY_INCIDENT_RECORD = 'FLAG_ACTIVITY_INCIDENT_RECORD';
